import { render, staticRenderFns } from "./CadPricingNotice.vue?vue&type=template&id=5b8e242e&scoped=true&"
import script from "./CadPricingNotice.vue?vue&type=script&lang=js&"
export * from "./CadPricingNotice.vue?vue&type=script&lang=js&"
import style0 from "./CadPricingNotice.vue?vue&type=style&index=0&id=5b8e242e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e242e",
  null
  
)

export default component.exports